import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=88c792e0&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LoginForm.vue?vue&type=style&index=1&id=88c792e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c792e0",
  null
  
)

export default component.exports